import AnnouncementBanner from "../components/AnnouncementBanner";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import FlowingText from "../components/FlowingText";
import StickyQuestion from "../components/StickyQuestion";
import HowItWorks from "../components/HowItWorks";
import LocationsSection from "../components/LocationsSection";
import PartnerCTA from "../components/PartnerCTA";
import Footer from "../components/Footer";

const NewHome = () => {
  return (
    <div className="min-h-screen bg-background">
      <AnnouncementBanner />
      <Navbar />
      <Hero />
      <FlowingText />
      <StickyQuestion />
      <HowItWorks />
      <LocationsSection />
      <PartnerCTA />
      <Footer />
    </div>
  );
};

export default NewHome;
